import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer.js'
import Slider from "react-slick"
import ProductTabs from '../../components/ProductTabs'
import SEO from '../../components/SEO/SEO';
import { seoData } from '../../utils/seoData';

const SodiumAluminatePage = () => {

    const productData = {
        description: [
            "Sodium Aluminate (NaAlO₂) is a versatile inorganic compound available in both solution and powder forms. It is widely used in water treatment, paper manufacturing, construction, and various industrial processes. The solution form offers ease of handling and dosing, while the powder form provides concentrated storage and transport benefits.",
            "Available in liquid solution (typically 25-45% concentration) and solid powder form to meet diverse application requirements.",
            "• Solution form - Drums/IBC: 200 L drums or 1000 L IBC containers with chemical-resistant lining for liquid handling and automated dosing systems.",
            "• Solution form - Bulk tankers: for large-scale operations requiring continuous supply with temperature-controlled transport.",
            "• Powder form - Bags: 25 kg or 50 kg multi-wall paper bags with moisture-resistant liner for easy handling and storage.",
            "• Powder form - Jumbo bags (FIBC): 500 kg to 1000 kg bulk bags for industrial-scale operations.",
            "• Packing & labeling: all packages supplied with technical specifications, Safety Data Sheets (SDS), and handling instructions. Proper sealing ensures product quality and prevents moisture absorption in powder form."
        ],
        applications: [
            {
                id: 1,
                title: "Water & Wastewater Treatment",
                description: "Sodium Aluminate is extensively used as a coagulant and pH adjuster in water treatment plants. It effectively removes suspended solids, turbidity, and organic matter. Preferred over alum in certain applications due to its alkaline nature and superior performance in cold water conditions.",
                image: "/images/products/sodium-aluminate/water.jpg"
            },
            {
                id: 2,
                title: "Paper & Pulp Industry",
                description: "Used in paper manufacturing for sizing, coating, and improving paper quality. Sodium Aluminate acts as a retention aid, drainage enhancer, and helps in controlling pitch deposits. Essential for producing high-quality paper products with improved strength and printability.",
                image: "/images/products/sodium-aluminate/paper.jpg"
            },
            {
                id: 3,
                title: "Construction & Concrete Admixtures",
                description: "Applied as an accelerator in concrete and cement formulations. Sodium Aluminate speeds up the setting time, improves early strength development, and enhances durability. Used in shotcrete, repair mortars, and specialized construction applications requiring rapid hardening.",
                image: "/images/products/sodium-aluminate/construction.jpg"
            },
            {
                id: 4,
                title: "Chemical Manufacturing & Industrial Processes",
                description: "Key raw material in producing zeolites, catalysts, and specialty chemicals. Used in textile processing, detergent manufacturing, and as a source of alumina in various chemical reactions. Essential in petroleum refining and environmental remediation applications.",
                image: "/images/products/sodium-aluminate/chemical.jpg"
            }
        ]
    };

    return (
        <Fragment>
            <SEO title={seoData.sodiumAluminate.title} description={seoData.sodiumAluminate.description} keywords={seoData.sodiumAluminate.keywords} />
            <Navbar/>
            <PageTitle pageTitle="Sodium Aluminate" pagesub="Sodium Aluminate" parentPage="Products" parentLink="#" />
            <div className="team-pg-area product-page-section">
                <div className="container">
                    <div className="team-info-wrap">
                        <div className="row align-items-center">
                            <div className="col-lg-6">
                                <div className="team-info-img">
                                    <Slider dots={true} arrows={true} infinite={true} speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={3000}>
                                        <div className="image-box">
                                            <img src='/images/products/sodium-aluminate/sa1.jpg' alt="Sodium Aluminate" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/sodium-aluminate/sa2.jpg' alt="Sodium Aluminate Solution" />
                                        </div>
                                        <div className="image-box">
                                            <img src='/images/products/sodium-aluminate/sa3.jpg' alt="Sodium Aluminate Powder" />
                                        </div>
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <div className="team-info-text">
                                    <h2>Sodium Aluminate (NaAlO₂)</h2>
                                    <ul>
                                        <li>Chemical Formula: <span>NaAlO₂</span></li>
                                        <li>Solution Concentration: <span>25-45%</span></li>
                                        <li>Powder Purity: <span>80-90%</span></li>
                                        <li>Packaging: <span>Drums, IBC, Bags, Bulk</span></li>
                                        <li>CAS Number: <span>1302-42-7</span></li>
                                        <li>Form: <span>Solution & Powder</span></li>
                                        <li>pH (Solution): <span>13-14 (Alkaline)</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProductTabs product={productData} />
                </div>
            </div>
            <Footer/>
            <Scrollbar/>
        </Fragment>
    )
};

export default SodiumAluminatePage;
